export default __webpack_public_path__ + "48dd819efe97b5e951489421b86387a9.jpg";